import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_DISCIPLINE, LIST_DISCIPLINE, REMOVE_DISCIPLINE, UPDATE_DISCIPLINE, VIEW_DISCIPLINE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const disciplineApi = createApi({
  reducerPath: 'disciplineApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/discipline",
  }),
  tagTypes: ["Disciplines", "DisciplinesLookup"],
  endpoints: (builder) => ({
    // get discipline profile list
    getDisciplineList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "name", direction: "ASC" } }) => ({
        method: "PATCH",
        url: LIST_DISCIPLINE,
        data: {
          search,
          status,
          page,
          limit,
          sort,
        },
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Disciplines"]
    }),

    // get discipline profile
    getDisciplineData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_DISCIPLINE}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Disciplines"]
    }),

    // create discipline profile
    createDiscipline: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_DISCIPLINE,
        data
      }),
      invalidatesTags: ["Disciplines"]
    }),

    // update discipline profile
    updateDiscipline: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_DISCIPLINE}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["Disciplines"]
    }),

    // delete discipline profile
    deleteDiscipline: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_DISCIPLINE}/${id}`
      }),
      invalidatesTags: ["Disciplines"]
    }),

    disciplineLookup: builder.query({
      query: (id) => ({
        method: "GET",
        url: "/"
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["DisciplinesLookup"]
    }),
  }),
})

export const {
  useGetDisciplineListQuery,
  useCreateDisciplineMutation,
  useGetDisciplineDataQuery,
  useUpdateDisciplineMutation,
  useDeleteDisciplineMutation,
  useLazyGetDisciplineListQuery,
  useDisciplineLookupQuery,
} = disciplineApi;